import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/active-ride-details.sass';

const LocationDisplay = ({ fieldKey }) => {
  const { state } = useContext(BookerContext);
  const { rideLater } = state;
  const { key, label, param } = fieldParams[fieldKey];

  return (
    <div className="address-wrapper">
      <div>{label}</div>
      <div className="address-info">{Object.keys(rideLater).length && rideLater[param]?.text}</div>
    </div>
  );
};

export default LocationDisplay;
